module.exports = __webpack_public_path__ + "static/img/cera.77539b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cera.png
// module id = m/fC
// module chunks = 1